import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface InfoTabState {

  selectedTab: 'Info' | 'AssetId' | 'Spans';
  showOverlay: boolean;
  bridgeFormTab: string;
};

const initialState: InfoTabState = {
    
    selectedTab: "Info",
    showOverlay: false,
    bridgeFormTab: '',
};

const leftViewSlice = createSlice({
  name: "infoTab",
  initialState,
  reducers: {
    setSelectedTab: (state, action: PayloadAction<InfoTabState['selectedTab']>) => {
      state.selectedTab = action.payload;
    },
    setShowOverlay: (state, action: PayloadAction<boolean>) => {
      state.showOverlay = action.payload;
    },
    setBridgeFormTab: (state, action: PayloadAction<string>) => {
      state.bridgeFormTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add extra reducers here
  },
});

export const { setBridgeFormTab, setSelectedTab, setShowOverlay } = leftViewSlice.actions;
export const selectLeftView = (state: any) => state.infoTab;
export const selectSelectedTab = (state: any) => state.infoTab.selectedTab;
export const selectShowOverlay = (state: any) => state.infoTab.showOverlay;
export const selectBridgeFormTab = (state: any) => state.infoTab.bridgeFormTab;
export default leftViewSlice.reducer;